import z from "zod"

/**
 * ColetaPrecoFornecedorSchema
 */

export const ColetaPrecoFornecedorSchema = z.object({
  familia: z.coerce.string().optional(),
  fornecedor: z.coerce.number({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
  produtosServicos: z.array(z.number()).nullable().default(null),
}).superRefine((data, ctx) => {
  if (data.fornecedor === null || data.fornecedor === undefined || data.fornecedor === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Este campo deve ser preenchido!',
      path: ['fornecedor'],
    });
  }
  if (data.produtosServicos === null || data.produtosServicos === undefined || data.produtosServicos.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Este campo deve ser preenchido!',
      path: ['produtosServicos'],
    });
  }
});

/**
 * ColetaPrecoFornecedorSchema
 */

export type ColetaPrecoFornecedorForm = z.infer<typeof ColetaPrecoFornecedorSchema>;